module.exports = __webpack_public_path__ + "img/asaas-logo.7b15768b.png";